import { jam } from '@jam.dev/sdk';

const JamMetadataPlugin = {
  install(Vue) {
    // Store base metadata and custom extensions
    const metadataStore = {
      baseMetadata: {},
      extensionCallbacks: [],
      
      // Method to extend with page-specific metadata
      extendMetadata(callback) {
        this.extensionCallbacks.push(callback);
        this.updateJamMetadata();
        return () => {
          // Return function to remove the extension when component is unmounted
          const index = this.extensionCallbacks.indexOf(callback);
          if (index !== -1) {
            this.extensionCallbacks.splice(index, 1);
            this.updateJamMetadata();
          }
        };
      },
      
      // Set base metadata that will be included everywhere
      setBaseMetadata(metadata) {
        this.baseMetadata = metadata;
        this.updateJamMetadata();
      },
      
      // Update the Jam metadata with base + extensions
      updateJamMetadata() {
        jam.metadata(() => {
          // Start with base metadata
          const metadata = {
            ...this.baseMetadata,
            timeSincePageLoad: performance.now(),
            currentRoute: window.location.pathname,
            userAgent: navigator.userAgent,
            screenSize: {
              width: window.innerWidth,
              height: window.innerHeight
            }
          };
          
          // Add extensions
          this.extensionCallbacks.forEach(callback => {
            try {
              const extendedData = callback();
              Object.assign(metadata, extendedData);
            } catch (error) {
              console.error('Error in Jam metadata extension:', error);
            }
          });
          
          return metadata;
        });
      }
    };
    
    // Add to Vue prototype
    Vue.prototype.$jamMetadata = metadataStore;
    
    // Also expose globally
    window.$jamMetadata = metadataStore;
  }
};

export default JamMetadataPlugin; 